<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>Housing Checkout - {{allocationPeriod}}</h2>
    <button mat-icon-button fxLayoutAlign="end center" (click)="close()">
        <mat-icon aria-label="Close" class="headerIconButton">close</mat-icon>
    </button>
</div>

<mat-dialog-content style="max-height: 95%; padding: 0 !important;" *ngIf="!showCheckoutInformation && allowEdit">
    <form [formGroup]="checkoutConfirmationFormGroup" (ngSubmit)="showCheckoutInformation = true" novalidate autocomplete="off">
        <mat-card class="mainStepperCard">
            <mat-card-content class="mainStepperCardContent">
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Terms and Conditions</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <div fxLayout="row" fxFlex="100%">
                                <span class="marginBottom0">This form contains important information regarding proper move out procedures. By checking all the boxes you agree to comply with the listed items.</span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Apartment and Room Condition</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <div fxLayout="row" fxFlex="100%">
                                <span>I understand that:</span>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="belongings" class="marginTop10" color="primary">All personal belongings must be removed from the apartment.</mat-checkbox>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="trash" class="marginTop10" color="primary">The instructions on how to donate, recycle or discard unwanted items received in my email must be read and followed.</mat-checkbox>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="sheets" class="marginTop10" color="primary">The sets of bed sheets and the towels must be placed neatly on my bed (washing them is not required).</mat-checkbox>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Luggage</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <!--NOT RETURNING STUDENT-->
                        <div fxLayout="column" *ngIf="!nextSemesterKeyCode">
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="luggage" class="marginTop10" color="primary">I understand I am not allowed to store my luggage in my housing assignment after the deadline to move out. JCU Housing will not provide me with storage space and I am responsible for removing my entire luggage from the premises.</mat-checkbox>
                            </div>
                        </div>

                        <!--RETURNING IN SAME APT-->
                        <div fxLayout="column" *ngIf="nextSemesterKeyCode && keyCode.substring(0, keyCode.indexOf('-')) == nextSemesterKeyCode.substring(0, nextSemesterKeyCode.indexOf('-'))">
                            <div fxLayout="row" fxFlex="100%">
                                <span>Returning to <strong>{{nextSemesterBuildingName}} ({{nextSemesterKeyCode}})</strong></span>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="luggage" class="marginTop10" color="primary">I understand I have to pack my luggage in labeled and sealed box(es) or suitcase(s) (plastic/paper bags will not be accepted) and bring it/them to the housing office no later than 2 business days prior to my departure. JCU Housing is not liable for any claims of damage, theft, or loss of students' personal property stored on the premises.</mat-checkbox>
                            </div>
                        </div>

                        <!--RETURNING to Different APT-->
                        <div fxLayout="column" *ngIf="nextSemesterKeyCode && keyCode.substring(0, keyCode.indexOf('-')) != nextSemesterKeyCode.substring(0, nextSemesterKeyCode.indexOf('-'))">
                            <div fxLayout="row" fxFlex="100%">
                                <span>Moving to <strong>{{nextSemesterBuildingName}} ({{nextSemesterKeyCode}})</strong></span>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="luggage" class="marginTop10" color="primary">I understand I have to pack my luggage in labeled sealed box(es) or suitcase(s) (plastic/paper bags will not be accepted) and bring it/them to the housing office no later than 2 business days prior to my departure. JCU Housing is not liable for any claims of damage, theft, or loss of students' personal property stored on the premises.</mat-checkbox>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Id Card and Keys</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <!--Trastevere -->
                        <div fxLayout="column" *ngIf="keyCode.charAt(0) == 'T'">
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="keys" class="marginTop10" color="primary">I will leave the keys to my apartment with the security guard.</mat-checkbox>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="card" class="marginTop10" color="primary" required>I will scan out with my student ID card at the guard’s station.</mat-checkbox>
                            </div>
                        </div>

                        <!--Gianicolo -->
                        <div fxLayout="column" *ngIf="keyCode.charAt(0) == 'D'">
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="keys" class="marginTop10" color="primary">I will leave the keys to my apartment with the security guard.</mat-checkbox>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="card" class="marginTop10" color="primary" required>I will scan out of the building with my student ID card.</mat-checkbox>
                            </div>
                        </div>

                        <!--Lungara -->
                        <div fxLayout="column" *ngIf="keyCode.charAt(0) == 'L'">
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="keys" class="marginTop10" color="primary">I will leave the keys on the kitchen table.</mat-checkbox>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="card" class="marginTop10" color="primary" required>I will scan out of the building with my student ID Card and leave it with the security guard.</mat-checkbox>
                            </div>
                        </div>

                        <!--Independent Apartments -->
                        <div fxLayout="column" *ngIf="!displayIndividualBuildings || keyCode.substring(0,3) == 'BBT' || (keyCode.charAt(0) == 'T' && keyCode.charAt(0) == 'D' && keyCode.charAt(0) == 'L') ">
                            <div fxLayout="row" fxFlex="100%">
                                <mat-checkbox formControlName="keys" class="marginTop10" color="primary">I will leave the keys and student ID Card on the kitchen table.</mat-checkbox>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-card-content>
            <mat-divider class="dividerColor"></mat-divider>
            <mat-card-actions fxLayoutAlign="end center">
                <button class="mat-raised-button dialogActionButton" mat-button (click)="close()" type="button">Cancel</button>
                <button class="mat-raised-button dialogActionButton" mat-button color="primary" type="submit" [disabled]="checkoutConfirmationFormGroup.invalid">Continue</button>
            </mat-card-actions>
        </mat-card>
    </form>
</mat-dialog-content>

<mat-dialog-content style="max-height: 95%; padding: 0 !important;" *ngIf="showCheckoutInformation || !allowEdit">
    <form [formGroup]="checkoutFormGroup" novalidate autocomplete="off" (ngSubmit)="saveCheckoutInformation(submitBtn)">
        <mat-card class="mainStepperCard">
            <mat-card-content class="mainStepperCardContent">
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Departure Information</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <div fxLayout="row" fxFlex="100%" fxLayoutAlign="center center">
                                <p class="redText fontSize16">All residents must vacate their housing assignments by <strong>12pm (noon)</strong> on <strong>{{moveOutDate | date: 'MMM dd yyyy'}}</strong></p>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <p class="fontSize14"><strong>Failure to vacate the premises by the designated time will result in a fine of {{currentUser.currencyId == 1 ? '€' : '$'}}{{lateCheckOutChargeAmount}}</strong></p>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap.gt-md="20px">
                            <mat-form-field fxFlex="50%" fxFlex.lt-lg="100%">
                                <input matInput [matDatepicker]="departureDate" placeholder="Departure Date (mm/dd/yyyy)" formControlName="departureDate" required [min]="today" [max]="moveOutDate" readonly (focus)="departureDate.open()">
                                <mat-datepicker-toggle matSuffix [for]="departureDate"></mat-datepicker-toggle>
                                <mat-datepicker #departureDate [touchUi]="isMobile"></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field fxFlex="50%" fxFlex.lt-lg="100%">
                                <input matInput placeholder="Departure Time" aria-label="Departure Time" [ngxTimepicker]="departureTime" formControlName="departureTime" readonly required [min]="'00:00 am'" [max]="isBeforeDeadline ? '11:59 pm' : '12:00 pm'">
                                <ngx-material-timepicker #departureTime [minutesGap]="5" [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn"></ngx-material-timepicker>

                                <ng-template #cancelBtn>
                                    <button class="mat-raised-button dialogActionButton marginRight10" mat-button type="button">Cancel</button>
                                </ng-template>
                                <ng-template #confirmBtn>
                                    <button class="mat-raised-button dialogActionButton" mat-button color="primary" type="button">Ok</button>
                                </ng-template>
                            </mat-form-field>
                        </div>
                        <div fxLayout="row" fxLayoutGap="5px">
                            <p>Note: The Housing and Residential Life Office <strong>will not</strong> be providing transportation from your housing assignment</p>
                        </div>
                    </mat-card-content>
                </mat-card>
                <mat-card class="stepperCard">
                    <mat-card-header>
                        <mat-card-title>Additional Information</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div fxLayout="column">
                            <div fxLayout="row" fxFlex="100%">
                                <p>We kindly ask you to leave the apartment in a condition of acceptable cleanliness. Make sure to organize with your roommate(s) on how to manage the cleaning schedule and necessary chores.</p>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <p>You may incur a <strong>{{currentUser.currencyId == 1 ? '€' : '$'}}{{nonReturnedKeysChargeAmount}}</strong> charge for keys which are not returned, for returning an unidentifiable key, or a different key from the one assigned to you; with the possibility of additional charges for a lock change and new keys, if it’s determined that the key was duplicated without permission.</p>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <p>Apartment Inspections will take place AFTER move-out. If there is evidence of damage caused by you or by your roommate(s) during your stay, you will be responsible for the proportional share, unless an individual takes full responsibility in writing by emailing <a href="mailto:housing@johncabot.edu" target="_top">housing@johncabot.edu</a> PRIOR to move-out.</p>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <p>Please clear any outstanding payments (e.g. on-site class fees) with the University prior to moving out. If you have an outstanding balance, you will not be able to receive your transcripts and/or register for classes. </p>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <p>If you wish to donate NON-PERISHABLE food, clothes, and/or books, you may follow the instructions sent via email.</p>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <p>By submitting this online check out form you agree to comply with the move out procedure outlined above. You may be subject to fines if you fail to follow the necessary steps or if the apartment condition upon move out does not meet the required standards.</p>
                            </div>
                            <div fxLayout="row" fxFlex="100%">
                                <p>This online check out form is functionally equivalent to providing your signature.</p>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </mat-card-content>
            <mat-divider class="dividerColor"></mat-divider>
            <mat-card-actions fxLayoutAlign="end center">
                <button class="mat-raised-button dialogActionButton" mat-button (click)="close()" type="button" *ngIf="allowEdit">Cancel</button>
                <button class="mat-raised-button dialogActionButton" mat-button color="primary" type="submit" [disabled]="checkoutFormGroup.invalid" *ngIf="allowEdit" #submitBtn>Submit</button>
                <button class="mat-raised-button dialogActionButton marginRight5" mat-button (click)="close()" type="button" color="primary" *ngIf="!allowEdit">Close</button>
            </mat-card-actions>
        </mat-card>
    </form>
</mat-dialog-content>
